import React from 'react';
import DonorsSection from '../components/DonorsSection';
import './WhereWeWork.css';

const AboutNORA: React.FC = () => {
  return (
    <DonorsSection />
  );
};

export default AboutNORA;